<template>
  <div class="container">
    <div v-for="(item, index) in list" :key="index" :style="item.style">

      <div v-if="Array.isArray(item)" class="qr-btn-img">
        <div v-for="(list, Index) in item" :key="Index" :style="list.style">
         <img v-if="!list.href" :src="item[Index].src">
         <a v-else :href="list.href" target="_blank"><img :src="item[Index].src"></a>
        </div>
      </div>
      <div v-else>
      <img v-if="!item.href" :src="item.src"/>
      <a v-else :href="item.href" target="_blank">
        <img :src="item.src"/>
      </a></div>
    </div>
  </div>
</template>

<script>
import utils from '@/util'

export default {
  name: 'landing',
  data () {
    return {
      items: [
        {
          src: 'https://static001.geekbang.org/resource/image/d6/7b/d62fe9a1d628d98d5ef3564eb0e9df7b.png',
          alt: '活动简介'
        },
        {
          src: 'https://static001.geekbang.org/resource/image/7a/b6/7a9b24124e194e706deaca87bc4f35b6.png',
          alt: '活动简介btn',
          href: 'https://www.bagevent.com/event/8944380'
        },
        {
          src: 'https://static001.geekbang.org/resource/image/2e/97/2e2cff867178cfa7cd1e8c167f8a8b97.png',
          alt: '议程安排'
        },
        [
          {
            src: 'https://static001.geekbang.org/resource/image/c4/88/c42da26bdbbf1b8bacb3c76d1e554388.png',
            alt: 'TGO学员报名二维码',
            style: 'width: 38.72%'
          },
          {
            src: 'https://static001.geekbang.org/resource/image/58/e5/5894ca2f13d159f8a697fa3c8db892e5.png',
            alt: 'TGO学员报名btn',
            style: 'width: 61.28%',
            href: 'https://tgo.infoq.cn/event/1454'

          }
        ],
        [
          {
            src: 'https://static001.geekbang.org/resource/image/d7/e1/d7e740072f0786daba2b51c5617f2ee1.png',
            alt: '非TGO学员报名二维码',
            style: 'width: 38.72%'
          },
          {
            src: 'https://static001.geekbang.org/resource/image/47/99/47cf0d803087350842470d2030c05499.png',
            alt: '非TGO学员报名btn',
            style: 'width: 61.28%',
            href: 'https://www.bagevent.com/event/8944380'
          }
        ],
        {
          src: 'https://static001.geekbang.org/resource/image/c3/bb/c3b4c67e75529d1e845dfda7ab9037bb.png',
          alt: '加会员免门票1'
        },
        {
          src: 'https://static001.geekbang.org/resource/image/fc/53/fc46cc9e5d2e4f709f65e35b8482ac53.png',
          alt: '加会员免门票2'
        },
        {
          src: 'https://static001.geekbang.org/resource/image/5f/47/5f997453aa80c065ed620981526a3547.png',
          alt: '底部logo'
        }
      ],
      // 梁宁巡回演讲
      liangningItems: [
        {
          src: 'https://static001.geekbang.org/resource/image/f1/c2/f13c793efe36557a8ac959b03c7a60c2.png'
        },
        {
          src: 'https://static001.geekbang.org/resource/image/2b/bc/2bedd1a653bf2f039b79a653d14a9dbc.png',
          href: 'https://www.bagevent.com/event/8939248'
        },
        {
          src: 'https://static001.geekbang.org/resource/image/6e/a9/6e54c1d8a4eeb04439cba187209420a9.png'
        },
        {
          src: 'https://static001.geekbang.org/resource/image/04/7c/04aa9a4cc6dfe752ff22123b544cde7c.png',
          href: 'https://gtlc.infoq.cn/2024/dawanqu'
        },
        {
          src: 'https://static001.geekbang.org/resource/image/92/8a/9250efd1166e0fc47c9b037629e2f38a.png'
        },
        {
          src: 'https://static001.geekbang.org/resource/image/f0/9f/f0c64ce17b34af74e32ea45b602ba39f.png',
          href: 'https://aicon.infoq.cn/202412/beijing'
        },
        {
          src: 'https://static001.geekbang.org/resource/image/e7/f8/e7d0f91fe1e600cb526af8569344eaf8.png'
        }
      ]
    }
  },
  computed: {
    list () {
      console.log(this.$route.name)
      return this.$route.name !== 'trainingshare' ? this.items : this.liangningItems
    }
  },
  mounted () {
    if (this.$route.name !== 'trainingshare') {
      utils.weixinshare({
        title: '马蒂·卡根带你理解“产品经营模式”',
        desc: '世界级产品大师马蒂·卡根助你摆脱增长困难、经营平庸困境！',
        imgUrl: 'https://static001.geekbang.org/resource/image/71/65/713dd801c400ef8cba525a459ca8eb65.jpg'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../style/bulma/app.sass";

.container {
  width: 680px;
  margin: 0 auto;
  // display: flex;
  img {
    vertical-align: middle;
    width: 100%;
    @include mobile {
      // margin-top: -1px;
    }
  }

  @include mobile {
    width: 100%;

  }
}
.qr-btn-img{
  display: flex;

}
</style>
